import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="font-mono-ui text-xs tracking-[0.28em] uppercase text-[#00E5FF] flex items-center gap-3">
          <span className="ring-dot" /> Verifying…
        </div>
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/hologram-club/login" state={{ from: location }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/hologram-club" replace />;
  }
  return children;
}
